import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState, useMemo, useCallback } from "react";
import { useTranslations } from "next-intl";
import { HostLegacy, LayoutLegacy } from "@silvertours/front-legacy-entities";
import { SearchForm } from "../SearchFormLegacy";
import { StageContentContainer, StageCaption, StageLink, StageWrapper } from "./Stage.styles";
import { StageContext } from "./context";
import { Error } from "./Error";
var IMAGE_PATH_PREFIX = "/bm/global/files/images/";
var Stage = function(param) {
    var content = param.content, link = param.link, statusCode = param.statusCode;
    var ref = content || {}, keyword = ref.keyword, search = ref.search, imageData = ref.image, includeSearch = ref.includeSearch;
    var t = useTranslations("features.stageLegacy.stage");
    var formatImage = HostLegacy.useHost().formatImage;
    var defaultImage = {
        src: t("defaultImage.src"),
        alt: t("defaultImage.alt"),
        id: t("defaultImage.id")
    };
    var image = imageData || defaultImage;
    var ref1 = useState(image.src), stageImage = ref1[0], setStageImage = ref1[1];
    var handleStageImageChange = useCallback(function(src) {
        var imageSrc = src ? "".concat(IMAGE_PATH_PREFIX).concat(src) : defaultImage.src;
        setStageImage(imageSrc);
    }, [
        defaultImage.src
    ]);
    var value = useMemo(function() {
        return {
            stageImage: stageImage,
            setStageImage: handleStageImageChange
        };
    }, [
        handleStageImageChange,
        stageImage
    ]);
    var newImage = _object_spread({}, image);
    if (image === defaultImage) {
        newImage.src = formatImage(stageImage || image.src);
    }
    return /*#__PURE__*/ _jsx(StageWrapper, {
        children: /*#__PURE__*/ _jsx(LayoutLegacy.ImageSegment, {
            id: "stage-image",
            image: newImage,
            isStage: true,
            includeSearch: includeSearch,
            children: /*#__PURE__*/ _jsx(StageContext.Provider, {
                value: value,
                children: /*#__PURE__*/ _jsxs(StageContentContainer, {
                    children: [
                        Boolean(link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/ _jsx(StageLink, {
                            href: link === null || link === void 0 ? void 0 : link.href,
                            target: link === null || link === void 0 ? void 0 : link.target,
                            children: link === null || link === void 0 ? void 0 : link.title
                        }),
                        includeSearch && /*#__PURE__*/ _jsx(StageCaption, {
                            children: /*#__PURE__*/ _jsx(SearchForm, {
                                stageTitle: keyword,
                                pageData: search
                            })
                        }),
                        /*#__PURE__*/ _jsx(Error, {
                            statusCode: statusCode
                        })
                    ]
                })
            })
        })
    });
};
export { Stage };
